import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkAuth } from 'store/modules/auth/actions'
import AccountComponent from 'bundles/Account/components/AccountComponent'

class AccountContainer extends Component {

    componentDidMount() {
        const { loggedIn, checkAuth } = this.props;

        if (!loggedIn) {
            checkAuth();
        }
    }

    componentDidUpdate(prevProps) {
        const { noAuthToken, history } = this.props;

        if (prevProps.noAuthToken !== noAuthToken && noAuthToken) {
            history.push('/');
        }
    }

    logout = () => {
        const { history } = this.props;

        history.push('/user/logout')
    }

    render() {
        const { user } = this.props;

        return (
            user && (
                <AccountComponent
                    user={user}
                    logout={this.logout}
                />
            )
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.auth.loggedIn,
        user: state.auth.user,
        noAuthToken: state.auth.noAuthToken,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        checkAuth: () => {
            dispatch(checkAuth())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountContainer)
